import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import EcolePromo from "@/pages/EcolePromo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <EcolePromo />
    </React.StrictMode>
);
